var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-baseline-error-outline",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e74a3b",
    style: {
      fill: "var(--color1, #e74a3b)"
    },
    d: "M14.667 20h2.667v2.667h-2.667V20zm0-10.667h2.667v8h-2.667v-8zm1.32-6.666C8.627 2.667 2.667 8.64 2.667 16s5.96 13.333 13.32 13.333c7.373 0 13.347-5.973 13.347-13.333S23.361 2.667 15.987 2.667zm.013 24c-5.893 0-10.667-4.773-10.667-10.667S10.106 5.333 16 5.333c5.893 0 10.667 4.773 10.667 10.667S21.894 26.667 16 26.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dce3e5",
    style: {
      stroke: "var(--color2, #dce3e5)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.667,
    d: "m20 24-8-8 8-8"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.667,
    d: "m12 24 8-8-8-8"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-done",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3cbc81",
    style: {
      fill: "var(--color3, #3cbc81)"
    },
    d: "m14.133 18.4-2.9-2.9c-.244-.244-.55-.361-.916-.349s-.673.138-.917.383-.367.556-.367.933c0 .378.122.689.367.933l3.8 3.8c.244.244.556.367.933.367s.689-.122.933-.367l7.567-7.567c.244-.244.361-.55.351-.917s-.14-.672-.384-.916-.556-.367-.933-.367c-.378 0-.689.122-.933.367l-6.6 6.6zM16 29.333c-1.844 0-3.578-.35-5.2-1.051s-3.033-1.649-4.233-2.849-2.15-2.611-2.849-4.233c-.7-1.622-1.051-3.356-1.051-5.2s.35-3.578 1.051-5.2c.7-1.622 1.649-3.033 2.849-4.233s2.611-2.15 4.233-2.851c1.622-.7 3.356-1.049 5.2-1.049s3.578.35 5.2 1.049c1.622.7 3.033 1.651 4.233 2.851s2.15 2.611 2.849 4.233c.7 1.622 1.051 3.356 1.051 5.2s-.35 3.578-1.051 5.2c-.7 1.622-1.649 3.033-2.849 4.233s-2.611 2.15-4.233 2.849c-1.622.7-3.356 1.051-5.2 1.051zm0-2.666c2.956 0 5.472-1.039 7.551-3.116s3.116-4.595 3.116-7.551c0-2.956-1.039-5.472-3.116-7.551S18.956 5.333 16 5.333c-2.956 0-5.472 1.039-7.549 3.116S5.334 13.044 5.334 16c0 2.956 1.039 5.472 3.117 7.551s4.594 3.116 7.549 3.116z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ellipse-blue",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#72c2f8",
    style: {
      fill: "var(--color4, #72c2f8)"
    },
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ellipse-blue-stroke",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#72c2f8",
    style: {
      stroke: "var(--color4, #72c2f8)"
    },
    strokeWidth: 2.971,
    d: "M30.514 16c0 8.016-6.498 14.514-14.514 14.514S1.486 24.016 1.486 16C1.486 7.984 7.984 1.486 16 1.486S30.514 7.984 30.514 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72c2f8",
    style: {
      fill: "var(--color4, #72c2f8)"
    },
    d: "M27.429 16c0 6.312-5.117 11.429-11.429 11.429S4.571 22.312 4.571 16 9.688 4.571 16 4.571 27.429 9.688 27.429 16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ellipse-orange",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3b249",
    style: {
      fill: "var(--color5, #f3b249)"
    },
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ellipse-orange-stroke",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f3b249",
    style: {
      stroke: "var(--color5, #f3b249)"
    },
    strokeWidth: 2.971,
    d: "M30.514 16c0 8.016-6.498 14.514-14.514 14.514S1.486 24.016 1.486 16C1.486 7.984 7.984 1.486 16 1.486S30.514 7.984 30.514 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3b249",
    style: {
      fill: "var(--color5, #f3b249)"
    },
    d: "M27.429 16c0 6.312-5.117 11.429-11.429 11.429S4.571 22.312 4.571 16 9.688 4.571 16 4.571 27.429 9.688 27.429 16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ellipse-pink",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea3d65",
    style: {
      fill: "var(--color6, #ea3d65)"
    },
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ellipse-pink-stroke",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ea3d65",
    style: {
      stroke: "var(--color6, #ea3d65)"
    },
    strokeWidth: 2.971,
    d: "M30.514 16c0 8.016-6.498 14.514-14.514 14.514S1.486 24.016 1.486 16C1.486 7.984 7.984 1.486 16 1.486S30.514 7.984 30.514 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea3d65",
    style: {
      fill: "var(--color6, #ea3d65)"
    },
    d: "M27.429 16c0 6.312-5.117 11.429-11.429 11.429S4.571 22.312 4.571 16 9.688 4.571 16 4.571 27.429 9.688 27.429 16z"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-circle-broken-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "M4.451 9.333a13.328 13.328 0 0 1 11.55-6.667c7.364 0 13.333 5.97 13.333 13.333s-5.97 13.333-13.333 13.333a13.329 13.329 0 0 1-11.55-6.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "M16 21.333 21.333 16 16 10.667M2.667 16h18.667"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar-check-02",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.667,
    d: "M28 13.333H4m24 3.334v-4.933c0-2.24 0-3.36-.436-4.216a3.991 3.991 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436H10.4c-2.24 0-3.36 0-4.216.436a3.991 3.991 0 0 0-1.748 1.748C4 8.374 4 9.494 4 11.734v11.2c0 2.24 0 3.36.436 4.216a3.991 3.991 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H16m5.333-26.667V8M10.667 2.667V8m8.666 17.333L22 28l6-6"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chart",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M23.8 9.037c0-.759.001-1.305.038-1.732.037-.436.103-.596.134-.648a.058.058 0 0 1 .015-.019h.001c.009-.006.045-.031.138-.06.208-.064.569-.112 1.207-.112s1 .048 1.207.112a.467.467 0 0 1 .138.06h.001c.004.003.007.005.015.019.031.052.097.212.134.648.037.427.037.973.037 1.732v13.926c0 .896-.051 1.503-.135 1.915-.084.414-.182.531-.199.548a.09.09 0 0 1-.029.02.68.68 0 0 1-.169.046c-.221.038-.511.041-1.002.041-.499 0-.793-.003-1.015-.042a.719.719 0 0 1-.168-.045c-.016-.008-.02-.012-.025-.017-.015-.016-.112-.131-.195-.547-.082-.413-.132-1.022-.132-1.92V9.036zM25.333 4.2c-1.288 0-2.612.136-3.305 1.291-.302.504-.403 1.084-.449 1.621-.046.535-.046 1.177-.046 1.884v13.968c0 .954.05 1.734.175 2.363.125.625.343 1.205.761 1.652.439.47.975.664 1.466.748.435.075.92.074 1.344.074h.107c.418 0 .9 0 1.333-.074.489-.084 1.023-.278 1.463-.745.42-.445.643-1.023.77-1.651.128-.63.18-1.412.18-2.367V8.996c0-.706 0-1.349-.046-1.884-.046-.536-.147-1.117-.449-1.621C27.944 4.336 26.62 4.2 25.332 4.2zm-10.828 8.467c-.033.301-.035.651-.035 1.111v9.811c-.033 1.146.175 1.533.299 1.666.107.115.376.279 1.23.279.834 0 1.112-.162 1.226-.283.127-.134.34-.522.303-1.658l-.001-.036v-9.778c0-.461-.001-.811-.035-1.111-.033-.296-.089-.448-.137-.529l-.002-.003c-.031-.053-.198-.335-1.356-.335s-1.324.282-1.356.335l-.002.003c-.049.081-.104.232-.137.529zm-1.807-1.694c.639-1.066 1.819-1.44 3.302-1.44s2.663.374 3.302 1.44c.284.475.395.99.445 1.444.049.438.049.908.049 1.328v9.793c.039 1.301-.16 2.461-.921 3.268-.777.823-1.869.995-2.875.995-1.015 0-2.112-.169-2.887-.999-.754-.808-.944-1.97-.909-3.261v-9.795c0-.42 0-.89.049-1.328.05-.454.161-.969.445-1.444zm-7.529 8.386c-.035.352-.036.776-.036 1.344v3.689c0 .641.155.816.23.88.122.103.453.261 1.303.261.832 0 1.167-.156 1.296-.264.081-.068.237-.247.237-.877v-3.669l-.009-.27c-.015-.439-.026-.782-.059-1.085-.039-.363-.099-.533-.146-.616l-.001-.002c-.012-.027-.127-.285-1.319-.285-1.196 0-1.336.261-1.355.297l-.001.003c-.046.078-.106.242-.141.593zm-1.813-1.741c.654-1.112 1.877-1.418 3.31-1.418 1.436 0 2.648.308 3.288 1.431.276.485.379 1.02.43 1.495.043.395.057.841.072 1.281l.009.257v3.729c0 .991-.256 1.949-1.047 2.613-.744.624-1.741.795-2.753.795-1.021 0-2.024-.169-2.767-.798-.79-.669-1.033-1.63-1.033-2.61v-3.725c0-.522 0-1.056.047-1.532.048-.487.155-1.029.442-1.517z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-icon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.667,
    d: "M16 10.667v10.667M10.667 16h10.667m7.999 0c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16C2.667 8.636 8.637 2.667 16 2.667S29.333 8.637 29.333 16z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-log-in-01",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.2,
    d: "M20 4h1.6c2.24 0 3.36 0 4.216.436a3.996 3.996 0 0 1 1.748 1.748C28 7.04 28 8.16 28 10.4v11.2c0 2.24 0 3.36-.436 4.216a4.001 4.001 0 0 1-1.748 1.748C24.96 28 23.84 28 21.6 28H20M13.333 9.333 20 16m0 0-6.667 6.667M20 16H4"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-log-out-01",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color7, #fff)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.2,
    d: "M21.333 22.667 28 16m0 0-6.667-6.667M28 16H12m0-12h-1.6c-2.24 0-3.36 0-4.216.436a3.991 3.991 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a3.996 3.996 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28H12"
  })), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-01",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.353,
    d: "M4 16h24M4 8h24M4 24h24"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-moon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3e85f3",
    style: {
      fill: "var(--color8, #3e85f3)"
    },
    d: "M27.656 17.393c-.904.24-1.834.361-2.769.361-2.847 0-5.52-1.107-7.528-3.115a10.712 10.712 0 0 1-2.752-10.298 1.33 1.33 0 0 0-.943-1.63 1.345 1.345 0 0 0-.69 0 13.346 13.346 0 0 0-5.985 3.443c-5.197 5.197-5.197 13.657 0 18.857a13.26 13.26 0 0 0 9.429 3.907 13.252 13.252 0 0 0 9.427-3.905 13.334 13.334 0 0 0 3.444-5.988 1.325 1.325 0 0 0-.346-1.285 1.34 1.34 0 0 0-1.285-.346zm-3.696 5.735a10.594 10.594 0 0 1-7.542 3.124 10.585 10.585 0 0 1-7.544-3.125c-4.157-4.159-4.157-10.927 0-15.085a10.562 10.562 0 0 1 2.747-1.977 13.365 13.365 0 0 0 3.854 10.464 13.29 13.29 0 0 0 10.464 3.854 10.704 10.704 0 0 1-1.979 2.745z"
  })), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pencil-01",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "m3.333 28.667 7.399-2.846c.473-.182.71-.273.931-.392.197-.106.384-.227.56-.364.198-.154.378-.333.736-.692l15.04-15.04A3.77 3.77 0 1 0 22.666 4L7.626 19.04c-.359.359-.538.538-.692.736a3.902 3.902 0 0 0-.364.561c-.119.221-.21.458-.392.931l-2.846 7.399zm0 0 2.744-7.135c.196-.511.295-.766.463-.883a.665.665 0 0 1 .505-.107c.201.038.395.232.782.619l3.012 3.012c.387.387.58.58.619.782a.665.665 0 0 1-.107.505c-.117.168-.372.267-.883.463l-7.135 2.744z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.667,
    d: "M16 6.667v18.667M6.667 16h18.667"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sun",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.324 16c0 3.681 2.995 6.676 6.676 6.676s6.676-2.995 6.676-6.676S19.681 9.324 16 9.324 9.324 12.319 9.324 16zM16 11.991c2.211 0 4.009 1.799 4.009 4.009S18.21 20.009 16 20.009c-2.211 0-4.009-1.799-4.009-4.009S13.79 11.991 16 11.991zm-1.336 13.342h2.667v4h-2.667v-4zm0-22.666h2.667v4h-2.667v-4zm-12 12h4v2.667h-4v-2.667zm22.667 0h4v2.667h-4v-2.667zM5.625 24.484l2.827-2.829 1.887 1.885-2.827 2.829-1.887-1.885zM21.653 8.459l2.829-2.829 1.885 1.885-2.829 2.829-1.885-1.885zM8.456 10.345 5.627 7.516l1.887-1.885 2.827 2.829-1.884 1.885zm17.912 14.14-1.885 1.885-2.829-2.829 1.885-1.885 2.829 2.829z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ea3d65",
    style: {
      stroke: "var(--color6, #ea3d65)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M4 8h24M25.333 8v18.667a2.67 2.67 0 0 1-2.667 2.667H9.333a2.668 2.668 0 0 1-2.667-2.667V8m4.001 0V5.333a2.668 2.668 0 0 1 2.667-2.667h5.333a2.67 2.67 0 0 1 2.667 2.667V8M13.333 14.667v8M18.667 14.667v8"
  })), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-3",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M4 8h24M25.333 8v18.667a2.67 2.67 0 0 1-2.667 2.667H9.333a2.668 2.668 0 0 1-2.667-2.667V8m4.001 0V5.333a2.668 2.668 0 0 1 2.667-2.667h5.333a2.67 2.67 0 0 1 2.667 2.667V8M13.333 14.667v8M18.667 14.667v8"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-04",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "M12 4h8M4 8h24M6.667 8l.801 12.018c.149 2.231.223 3.347.588 4.243a6 6 0 0 0 3.672 3.435c.919.304 2.037.304 4.273.304 2.236 0 3.354 0 4.273-.304a5.999 5.999 0 0 0 3.671-3.435c.365-.896.439-2.012.588-4.243L25.334 8"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-check-01",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.667,
    d: "M21.333 24 24 26.667l5.333-5.333M16 20.667h-6c-1.861 0-2.791 0-3.548.23a5.331 5.331 0 0 0-3.555 3.556c-.23.757-.23 1.687-.23 3.548v0M13.333 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.667,
    d: "M24 8 8 24M8 8l16 16"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-grey-star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.741 32c-0.409-0.001-0.786-0.139-1.088-0.369l0.004 0.003-7.657-5.737-7.657 5.737c-0.298 0.227-0.675 0.363-1.083 0.363-0.413 0-0.793-0.139-1.097-0.373l0.004 0.003c-0.313-0.242-0.548-0.571-0.668-0.951l-0.004-0.014c-0.059-0.181-0.092-0.388-0.092-0.604 0-0.21 0.032-0.413 0.092-0.604l-0.004 0.014 2.853-9.634-7.589-5.589c-0.312-0.244-0.545-0.576-0.664-0.958l-0.004-0.014c-0.057-0.179-0.090-0.384-0.090-0.598s0.033-0.419 0.094-0.612l-0.004 0.014c0.124-0.395 0.359-0.724 0.668-0.964l0.004-0.003c0.297-0.231 0.675-0.371 1.085-0.375h0.001l9.397-0.016 2.999-9.394c0.127-0.392 0.363-0.72 0.672-0.957l0.005-0.003c0.299-0.227 0.677-0.364 1.087-0.364s0.788 0.137 1.091 0.367l-0.004-0.003c0.314 0.24 0.55 0.568 0.673 0.946l0.004 0.014 2.942 9.394 9.445 0.016c0.412 0.003 0.79 0.144 1.092 0.378l-0.004-0.003c0.312 0.243 0.546 0.573 0.666 0.953l0.004 0.014c0.057 0.179 0.090 0.384 0.090 0.598s-0.033 0.419-0.094 0.612l0.004-0.014c-0.122 0.396-0.354 0.727-0.661 0.968l-0.004 0.003-7.589 5.589 2.857 9.632c0.055 0.176 0.087 0.377 0.087 0.587 0 0.217-0.034 0.427-0.098 0.623l0.004-0.014c-0.124 0.394-0.359 0.723-0.668 0.961l-0.005 0.003c-0.299 0.232-0.679 0.372-1.093 0.373h-0z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-right-slide-arrow",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.936 14.79l1.203 0.818-22.876 0.001v0.64l22.733-0.001-1.133 0.651 0.319 0.555 2.607-1.498-2.492-1.695-0.36 0.529z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-left-slide-arrow",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.966 17.068l-1.203-0.818h22.876v-0.64h-22.733l1.133-0.651-0.319-0.555-2.607 1.498 2.492 1.695 0.36-0.53z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3e85f3",
    style: {
      fill: "var(--color1, #3e85f3)"
    },
    opacity: 0.18,
    d: "M32.244 29.333c-2.343-4.051-5.954-6.955-10.168-8.332 2.084-1.241 3.704-3.132 4.61-5.382s1.048-4.736 0.404-7.074c-0.643-2.339-2.037-4.402-3.966-5.872s-4.288-2.267-6.714-2.267-4.784 0.796-6.714 2.267c-1.929 1.47-3.323 3.533-3.966 5.872s-0.501 4.824 0.404 7.074c0.906 2.25 2.525 4.141 4.61 5.382-4.214 1.375-7.825 4.28-10.168 8.332-0.086 0.14-0.143 0.296-0.168 0.459s-0.017 0.328 0.024 0.488 0.112 0.309 0.212 0.44c0.099 0.131 0.224 0.241 0.366 0.323s0.3 0.135 0.463 0.155c0.163 0.020 0.329 0.008 0.487-0.037s0.306-0.12 0.434-0.223 0.235-0.23 0.313-0.374c2.898-5.009 8.021-8 13.703-8s10.805 2.991 13.703 8c0.078 0.144 0.185 0.272 0.313 0.374s0.276 0.178 0.434 0.223c0.158 0.045 0.324 0.057 0.487 0.037s0.32-0.073 0.463-0.155c0.142-0.082 0.267-0.192 0.366-0.323s0.171-0.281 0.212-0.44c0.040-0.159 0.048-0.325 0.024-0.488s-0.082-0.318-0.168-0.459zM7.795 11.487c0-1.704 0.505-3.37 1.452-4.786s2.292-2.521 3.866-3.173c1.574-0.652 3.307-0.823 4.978-0.49s3.206 1.153 4.411 2.358c1.205 1.205 2.025 2.74 2.358 4.411s0.162 3.404-0.49 4.978c-0.652 1.574-1.756 2.92-3.173 3.866s-3.082 1.452-4.786 1.452c-2.284-0.002-4.474-0.911-6.089-2.526s-2.524-3.805-2.526-6.089z"
  })), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.5556,
    d: "M8 12l8 8 8-8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.8f0c0be94bc71b438f72f66da1b68dc5.svg";
export { ForwardRef as ReactComponent };